import { Link } from '@remix-run/react'

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			{/* TODO: Add Meta */}
			{/* <Helmet
        title="About the Stan Steele Agency"
        meta={[
          {
            name: "description",
            content: "We are here to help you. Let us show you.",
          },
          {
            name: "keywords",
            content: "About the Stan Steele Agency",
          },
        ]}
      /> */}
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>
			<br />
			<br />
			<h1 className="text-4xl font-black">Our Story</h1>

			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Our story starts with a young farmer named{' '}
				<Link
					to="/about-us/stan-steele/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					Stan Steele
				</Link>{' '}
				who lived in Bloomfield, NY. He needed insurance for his farm and the
				more he learned about the insurance industry the more he liked it. He
				eventually became an independent agent and was then able to help his
				friends and neighbors find insurance for their homes, cars, farms, and
				small businesses. Over the years, he developed relationships within the
				community and with insurance carriers small and large. His insurance
				business began to take a more prominent role in his life and his career
				as an insurance agent blossomed.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<Link
					to="/articles/the-three-types-of-insurance-agents/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					Learn more about the different types of Insurance Agents
				</Link>
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Today, the Steele Agency has relationships with{' '}
				<Link
					to="/our-insurance-company-relationships/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					respected insurance companies
				</Link>{' '}
				to provide a variety of products to meet the needs of families, small
				businesses, contractors, nonprofits, and municipalities. We're still
				family-owned and fulfilling the dream that Stan had so many years ago.
			</p>

			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				We are part of{' '}
				<Link
					to="/about-us/united-wealth-advisors-group"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					United Wealth Advisors Group
				</Link>{' '}
				in order to serve more of the needs of our clients.
			</p>
			<h1 className="py-3 text-4xl font-black">About Us</h1>

			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<Link
					to="/about-us/joel-steele/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Joel</h2>
				</Link>

				{/* <Link
					to="/about-us/nicole-stephenson/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Nicole</h2>
				</Link> */}

				<Link
					to="/about-us/mathieu-steele/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Matt</h2>
				</Link>

				<Link
					to="/about-us/dina-gmeinweiser/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Dina</h2>
				</Link>

				<Link
					to="/about-us/daren-forrest/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Daren</h2>
				</Link>

				{/* <Link
					to="/about-us/rachel-santevecchi/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Rachel</h2>
				</Link> */}

				{/* <Link
					to="/about-us/savannah-steele/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Savannah</h2>
				</Link>

				<Link
					to="/about-us/stacey-milton/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Stacey</h2>
				</Link>

				<Link
					to="/about-us/ryan-wood/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Ryan</h2>
				</Link>

				<Link
					to="/about-us/jon-marble/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Jon</h2>
				</Link> */}

				<Link
					to="/about-us/dan-miles/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					<h2>Dan</h2>
				</Link>
			</p>
		</main>
	)
}
